<!-- 마이보드 > 마이보드 상세 -->
<template>
  <div class="tabCont">
    <div class="p-inner ty01">
      <div class="tit-group02">
        <h2 class="tit">{{sendTitle}}</h2>
      </div>
      <div class="content-box">
        <div class="tit-group02 inner-ty">
          <h2 class="tit">Total: {{totalCnt}}</h2>
          <div class="filter-btn-group">
            <v-btn class="reset" :class="filterDiv1" @click="onClickInitFilter">{{t('message.filterInit')}}</v-btn>
            <v-btn class="filter" @click="filterOpen1" :class="filterDiv1">{{t('message.filter')}}</v-btn>
          </div>
        </div>
        <div class="sort-group" :class="filterDiv1">
          <div class="sort-row">
            <div class="wl">
              <div class="txt-total">Total: {{ totalCnt }}</div>
              <c-inputSearch v-bind="inputSearch" v-model="searchModel" @search-word="onClickSearch" @keyup.enter="onClickSearch"/>
              <div class="date-sort">
                <c-InputDate :enableTimePicker="false" readonly="" v-model="startDate"/>
                <div class="txt02">~</div>
                <c-InputDate :enableTimePicker="false" readonly="" v-model="endDate"/>
              </div>
              <div class="date-sort">
                <c-btn02 :btnText="t('message.oneWeek')" class="ty01" @click="onClickDate('week')"/>
                <c-btn02 :btnText="t('message.oneMonth')" class="ty01" @click="onClickDate('month')"/>
              </div>
              <Select v-bind="statusSelect" v-model="status"/>
            </div>
          </div>
        </div>
        <div class="tbl-group size-custom5">
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page-options="footerOptions"
            return-object
          >
            <template v-slot:item="{ item }">
              <tr class="v-data-table__tr" @click="utils.movePage('/myBoardDetail/'+item.idx)">
                <td>{{item.idx}}</td>
                <td>
                  <div class="ell01">
                    {{item.situation}}
                  </div>
                </td>
                <td>
                  <div :class="getColor(item.goalDate)">
                    {{item.goalDate}}
                  </div>
                </td>
                <td>{{item.memberName}}</td>
                <td>{{item.targetText}}</td>

                <td>
                  <div :class="getColor2(item.status)">
                    {{item.statusText}}
                  </div>
                </td>
                <td>
                  <div class="dv1">
                    <div class="ico" :class="getColor2(item.status)">
                      {{item.statusText}}
                    </div>
                    <div class="ell01">
                      {{item.situation}}
                    </div>
                  </div>
                  <div class="dv2">
                    <div :class="getColor(item.goalDate)">
                      {{item.goalDate}}
                    </div>
                    &nbsp;/ {{item.memberName}} / {{item.targetText}}
                  </div>
                </td>
                <td>{{item.modDateFormat}}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
    <div class="bottom-btn-group">
      <div class="wl">
        <c-btnLine01 :btnText="t('message.list')" @click.stop="onClickGoList()"/>
      </div>
    </div>
  </div>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue'
import { useCommonStore } from "@/store/common";
import {storeToRefs} from "pinia";
import TimelineService from "@/services/timeline.service";
import utils from "@/common/Utils";
import _ from 'lodash';
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//1:나의시정 2:부서시정 3:나의칭찬 4:부서칭찬
const props = defineProps(['tabType'])
//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const items:any = ref([])
const searchModel = ref('')
const totalCnt = ref(0)
const startDate = ref(dayjs().startOf('month').format('YYYY-MM-DD'))
const endDate = ref(dayjs().endOf('month').format('YYYY-MM-DD'))
const status = ref('')
const sendTitle = ref('')
const snackbar = ref(false)
const snackText = ref('')

//ui
const inputSearch = computed(() =>( {
  type: 'text',
  placeholder: t('message.searchPlaceholder'),
} ))
const statusSelect = computed(() =>( {items: [{name:t('message.all'), value:''},{name:t('message.inProgress'), value:'2'},{name:t('message.onHold'), value:'3'},{name:t('message.complete'), value:'4'}]} ))
const headers = computed(() =>( [
  { title: t('message.orderNumber'), key: 'idx' },
  { title: t('message.correctiveAction'), key: 'situation' },
  { title: t('message.actionDeadline'), key: 'goalDate'},
  { title: t('message.author'), key: 'memberName' },
  { title: t('message.targetPerson'), key: 'targetText' },
  { title: t('message.progressStatus'), key: 'statusText' },
  { title: t('message.correctiveActionSummary'), key: 'moDate' },
  { title: t('message.registrationDate'), key: 'modDateFormat' },
] ))
const footerOptions = [
  { value: 5, title: '5' },
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
]

//watch
watch(startDate, (newObj) => {
  onClickSearch()
})

watch(endDate, (newObj) => {
  onClickSearch()
})

watch(status, (newObj) => {
  onClickSearch()
})

//hook
onMounted(() => {
  onClickSearch()
})

//function
const onClickSearch=()=>{
  if(storeRef.senderType.value == 'send')
    sendTitle.value = t('message.issuedCorrectiveActions')
  else if(storeRef.senderType.value == 'receive')
    sendTitle.value = t('message.receivedCorrectiveActions')
  const tab = storeRef.tabName.value
  const curTab = props.tabType
  if(tab != curTab)
    return

  const user = JSON.parse(localStorage.getItem('user'))
  const currentCompanyIdx = localStorage.getItem('companyIdx')
  let deptIdx = user.deptIdx
  let memberIdx = user.memberIdx
  //1,3은 개인 2,4는 부서
  if(props.tabType == 'tabCont1' || props.tabType == 'tabCont3')
    deptIdx = 0
  else
    memberIdx = 0
  let params = {
    companyIdx:_.includes([null, undefined, '', 0], user.companyIdx) ? currentCompanyIdx : user.companyIdx,
    memberIdx:memberIdx,
    deptIdx:deptIdx,
    keyword:searchModel.value,
    startDate: startDate.value,
    endDate: endDate.value,
    status: status.value,
  }
  TimelineService.getTimelineSummary(params).then(
    (response) => {
      //send, receive 선택
      if(storeRef.senderType.value == 'send')
        items.value = response.result.sendTimelines
      else
        items.value = response.result.receiveTimelines
      //안전대화, 지지적 분리
      items.value = _.filter(items.value, {type:(props.tabType == 'tabCont1' || props.tabType == 'tabCont2')?'1':'2'})
      //상세데이터 변경
      _.forEach(items.value, (val, key)=> {
        val.actionYnText = val.actionYn=='Y'?t('message.necessary'):t('message.notNecessary')
        val.targetText = t('message.none')
        if(val.targetType == '2') val.targetText = val.targetDeptName
        else if(val.targetType == '3') val.targetText = val.targetMemberName
        val.goalDate = dayjs(val.goalDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(val.goalDate).format('YYYY-MM-DD')
        val.statusText = t('message.ready')
        if(val.status == '2')
          val.statusText = t('message.inProgress')
        else if(val.status == '3')
          val.statusText = t('message.onHold')
        else if(val.status == '4')
          val.statusText = t('message.complete')
      })
      totalCnt.value = items.value.length
    },
    (error) => {
      if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
    }
  )
}
const getColor=(goalDate)=> {
  const startDate = dayjs();
  const endDate = dayjs(goalDate);
  const duration = endDate.diff(startDate, 'days');
  if (duration < 7)
    return 'txt-red'
}
const getColor2=(status)=> {
  if (status == '2') return 'txt-blue'
  else if (status == '3') return 'txt-red'
}
const onClickGoList=()=>{
  //store.moveTab(props.tabType)  tabview 이름이 여러개일때만 사용가능
  storeRef.isTabView1.value = false
}
const onClickDate=(type)=>{
  const end = dayjs().format('YYYY-MM-DD')
  let start = dayjs().format('YYYY-MM-DD')
  if(type == 'week')
    start = dayjs().subtract(7, 'day').format('YYYY-MM-DD')
  else if(type == 'month')
    start = dayjs().subtract(4, 'month').format('YYYY-MM-DD')

  startDate.value = start.toString()
  endDate.value = end.toString()
}
//{{t('message.filter')}} 메뉴 열고 닫기
const filterDiv1 = ref('off')
const filterOpen1=()=>{
  if(filterDiv1.value == 'off')
    filterDiv1.value = 'on'
  else
    filterDiv1.value = 'off'
}

const onClickInitFilter=()=>{
  searchModel.value = ''
  startDate.value = ''
  endDate.value = ''
  status.value = ''
}
</script>


<style lang="scss" >
</style>
